import React from 'react';
import './ScoreGauge.css';

export default function ScoreGauge({ score, label, type = 'benefit', size = 'normal' }) {
  const isBenefit = type === 'benefit';
  const color = isBenefit
    ? score >= 80 ? '#10b981' : score >= 60 ? '#f59e0b' : '#ef4444'
    : score <= 25 ? '#10b981' : score <= 45 ? '#f59e0b' : '#ef4444';

  const circumference = 2 * Math.PI * 36;
  const offset = circumference - (score / 100) * circumference;

  return (
    <div className={`score-gauge score-gauge--${size}`}>
      <div className="score-gauge-ring">
        <svg viewBox="0 0 80 80" className="score-gauge-svg">
          <circle cx="40" cy="40" r="36" fill="none" stroke="#1e293b" strokeWidth="6" />
          <circle
            cx="40" cy="40" r="36"
            fill="none"
            stroke={color}
            strokeWidth="6"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 40 40)"
            style={{ transition: 'stroke-dashoffset 1s ease, stroke 0.3s' }}
          />
        </svg>
        <div className="score-gauge-value" style={{ color }}>
          {score}
        </div>
      </div>
      <div className="score-gauge-label">{label}</div>
    </div>
  );
}